import { CreateStyled } from '@emotion/styled';

/**
 * @see
 * https://github.com/emotion-js/emotion/issues/2193#issuecomment-766173118
 * @example
 * const SomeComponent = styled(
 Typography,
 transientOptions,
 )<{ $customProp: boolean }>(({ theme, $customProp }) => ({...}));
 */
export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};
